import { Maybe, SlackChannel, SlackChannelInput } from 'generated/graphql';

export const mapEdgeDataToChannelsInWorkspace = (
  channels: Maybe<SlackChannel>[],
): SlackChannelInput[] => {
  return channels?.map((channel) => ({
    name: channel?.name ?? '',
    id: channel?.id ?? '',
    isPrivate: channel?.isPrivate ?? false,
  }));
};
